export class Mark {
  id?: any;
  lat?: any;
  lng?: any;
  color?: string = 'blue';
  data?: any;
}
